import { PRIMARY, TERTIARY, makeThemeColor } from '@tornado-rdk/theme';
import { safetyMargins, FULL_HD, HD } from '@bedrock-rdk/constants';
import { getFont, FONT } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../../../tornado/utils/style';
import { SCREEN_HEIGHT, SCREEN_WIDTH } from '../../../tornado/utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  background: makeThemeColor(TERTIARY),
  title: makeThemeColor(PRIMARY),
};

export const CONTENT_WIDTH = {
  [HD]: SCREEN_WIDTH[HD] - safetyMargins.horizontal[HD] * 2,
  [FULL_HD]: SCREEN_WIDTH[FULL_HD] - safetyMargins.horizontal[FULL_HD] * 2,
};

export const CONTENT_HEIGHT = {
  [HD]: SCREEN_HEIGHT[HD] - safetyMargins.vertical[HD] * 2,
  [FULL_HD]: SCREEN_HEIGHT[FULL_HD] - safetyMargins.vertical[FULL_HD] * 2,
};

export const TEXT_OFFSET = 40;

export const getInitialStyle = ({ screenSize, colorMode } = defaultContext) => ({
  zIndex: 1,
  Background: {
    w: SCREEN_WIDTH[screenSize],
    h: SCREEN_HEIGHT[screenSize],
    color: colors.background[colorMode],
  },
  BackButton: {
    x: safetyMargins.horizontal[screenSize],
    y: safetyMargins.vertical[screenSize],
  },
  Content: {
    w: CONTENT_WIDTH[screenSize],
    h: CONTENT_HEIGHT[screenSize],
    x: safetyMargins.horizontal[screenSize],
    y: safetyMargins.vertical[screenSize],
    flex: {
      direction: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    Title: {
      text: {
        ...getFont(FONT.PARIS_3, screenSize),
        maxLines: 2,
        maxLinesSuffix: '...',
        wordWrapWidth: CONTENT_WIDTH[screenSize],
        textAlign: 'center',
        textColor: colors.title[colorMode],
      },
    },
    Body: {
      flexItem: { marginTop: TEXT_OFFSET },
      text: {
        ...getFont(FONT.OTTAWA_1, screenSize),
        maxLines: 2,
        maxLinesSuffix: '...',
        wordWrapWidth: CONTENT_WIDTH[screenSize],
        textAlign: 'center',
        textColor: colors.title[colorMode],
      },
    },
    HomeButton: {
      flexItem: { marginTop: TEXT_OFFSET },
    },
  },
});
